import { createFileRoute } from '@tanstack/react-router';
import { FirstTimePasswordResetScreen } from '@/auth/FirstTimePasswordResetScreen';

export const Route = createFileRoute('/_auth/first-time-password-reset')({
  component: FirstTimePasswordResetScreen,
  validateSearch: (search: Record<string, unknown>): { email?: string } => ({
    // Passed by the login form's redirect to prefill the field. Only a prefill:
    // the server looks the address up itself.
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
});
